import React, { useState, useEffect } from 'react';
import { useControls } from "react-zoom-pan-pinch";

const Controls = ({ changeChannel, element, style, showZoomControls }) => {
    const { zoomIn, zoomOut, resetTransform } = useControls();
    const v = element?.style;
    if (v) { v.position = 'relative' };
    if (changeChannel === 0) { resetTransform() };

    useEffect(() => {
        if (v) {
            resetTransform();
            v.top = 0;
            v.left = 0;
        }
    }, [changeChannel]);

    const available = (i) => {
        const e = element.getBoundingClientRect();
        const w = document.getElementsByClassName('react-transform-wrapper')[0].getBoundingClientRect();
        if (i === 'top') return (e.top + 20) <= w.top;
        if (i === 'left') return (e.left + 20) <= w.left;
        if (i === 'bottom') return (e.bottom - 20) >= w.bottom;
        if (i === 'right') return (e.right - 20) >= w.right;
    }

    if (showZoomControls) {
        return (
            <div className='vjs-zoom__container' style={{ bottom: style.bottom, right: style.right }}>
                <div className="vjs-zoom__container--row">
                    <button id="vjs-zoom__zoomIn" className="vjs-zoom__button" onClick={() => zoomIn()}>
                        <span className="vjs-zoom-icons">add</span>
                    </button>
                    <span className="vjs-zoom__space"></span>
                    <button id="vjs-zoom__zoomOut" className="vjs-zoom__button" onClick={() => zoomOut()}>
                        <span className="vjs-zoom-icons">remove</span>
                    </button>
                </div>
                <div className="vjs-zoom__container--row">
                    <span className="vjs-zoom__space"></span>
                    <button id="vjs-zoom__moveUp" className="vjs-zoom__button" onClick={() => { available('top') && (v.top = (parseInt(v.top || 0, 10) + 20) + 'px') }}>
                        <span className="vjs-zoom-icons">arrow_drop_up</span>
                    </button>
                    <span className="vjs-zoom__space"></span>
                </div>
                <div className="vjs-zoom__container--row">
                    <button id="vjs-zoom__moveLeft" className="vjs-zoom__button" onClick={() => { available('left') && (v.left = (parseInt(v.left || 0, 10) + 20) + 'px') }}>
                        <span className="vjs-zoom-icons">arrow_left</span>
                    </button>
                    <button id="vjs-zoom__reset" className="vjs-zoom__button" onClick={() => {
                        resetTransform();
                        v.top = 0;
                        v.left = 0;
                    }}>
                        <span className="vjs-zoom-icons">fiber_manual_record</span>
                    </button>
                    <button id="vjs-zoom__moveRight" className="vjs-zoom__button" onClick={() => { available('right') && (v.left = (parseInt(v.left || 0, 10) - 20) + 'px') }}>
                        <span className="vjs-zoom-icons">arrow_right</span>
                    </button>
                </div>
                <div className="vjs-zoom__container--row">
                    <span className="vjs-zoom__space"></span>
                    <button id="vjs-zoom__moveDown" className="vjs-zoom__button" onClick={() => { available('bottom') && (v.top = (parseInt(v.top || 0, 10) - 20) + 'px') }}>
                        <span className="vjs-zoom-icons">arrow_drop_down</span>
                    </button>
                    <span className="vjs-zoom__space"></span>
                </div>
            </div>
        )
    } else {
        return <></>
    };
};

export default Controls;
